import { apiAddSegment } from '@ve-pro/api/project'
import { AddSegmentParams, ProjectSegmentModel } from '@ve-pro/api/project/type'
import { AssetType } from '@ve-pro/enums/asset'
import { SegmentType } from '@ve-pro/enums/segment'
import type { SegmentCollection, Track } from '@ve-pro/types/track.type'
import shortid from 'shortid'
import { useProjectStore } from '../project'
import { isSegmentFragment } from './segment/segment-fragment'

export const TRACK_PREFIX = 'TRACK_'
export const SEGMENT_PREFIX = 'SEGMENT_'

export function generateTrackId(): Track['id'] {
  return `${TRACK_PREFIX}${shortid.generate()}`
}

export function isClientCreatedTrackId(id: string): boolean {
  const pattern = new RegExp(`^${TRACK_PREFIX}`)
  return pattern.test(id)
}

export async function generateSegmentIdFromService(
  segment: SegmentCollection,
): Promise<SegmentCollection['id']> {
  const projectStore = useProjectStore()
  const params: AddSegmentParams = isSegmentFragment(segment)
    ? {
        segment_type: SegmentType.Fragment,
        project_id: projectStore.id,
        stage: projectStore.mode,
      }
    : {
        stage: projectStore.mode,
        asset_ids: segment.asset_id ? [segment.asset_id] : [],
        project_id: projectStore.id,
        text: segment.type === SegmentType.Text ? [segment.text] : [],
        type:
          segment.type === SegmentType.Text
            ? AssetType.Text
            : segment.material.type,
      }

  const res = await apiAddSegment(params)

  return res.data.data.segments[0]!.id
}

export async function bathGenerateSegmentIdFromService(
  segments: SegmentCollection[],
  text: string[],
): Promise<ProjectSegmentModel[]> {
  const projectStore = useProjectStore()
  const res = await apiAddSegment({
    stage: projectStore.mode,
    asset_ids: segments.map((s) => s.asset_id),
    project_id: projectStore.id,
    text: segments[0]!.type === SegmentType.Text ? text : [],
    type:
      segments[0]!.type === SegmentType.Text
        ? AssetType.Text
        : segments[0]!.asset_type,
  })

  return res.data.data.segments
}
